'use client';

import { useEffect, useState } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { getServiceById } from '@/lib/actions/services';
import { getServiceCategories } from '@/lib/actions/service-categories';
import { getInsights } from '@/lib/actions/insights';
import { ServiceForm } from '@/components/admin/services/ServiceForm';

export default function AdminServiceEditPage() {
  const { id } = useParams<{ id: string }>();
  const [service, setService] = useState<Awaited<ReturnType<typeof getServiceById>>>(null);
  const [categories, setCategories] = useState<Awaited<ReturnType<typeof getServiceCategories>>>([]);
  const [insights, setInsights] = useState<Awaited<ReturnType<typeof getInsights>>>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!id) return;
    Promise.all([getServiceById(id), getServiceCategories(), getInsights()]).then(
      ([serviceData, categoriesData, insightsData]) => {
        setService(serviceData);
        setCategories(categoriesData);
        setInsights(insightsData);
        setLoading(false);
      }
    );
  }, [id]);

  if (loading) {
    return null;
  }

  if (!service) {
    return <Navigate to="/admin/services" replace />;
  }

  return <ServiceForm initialData={service} categories={categories} allInsights={insights} />;
}
